export default "__VITE_ASSET__Bc10c8mx__"